<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="View Vehicle Bus Route Details">
        <v-card-actions>
          <router-link :to="{ name: 'addVehicleBusRoute', params: {} }" title="Create Vehicle Bus Route">
            <v-btn absolute right top elevation="1" color="primary">
              <v-icon left>mdi-plus</v-icon>
              create Vehicle Bus Route
            </v-btn>
          </router-link>

        </v-card-actions>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="vehicleBusRoute"
            :search="search"
          >
            <template v-slot:item.vehicleDetail="{ item }">
              {{ item.vehicleDetail.vehicleRegistrationNumber || '-' }}
            </template>
            <template v-slot:item.routeName="{ item }">
              {{ item.routeName || '-' }}
            </template>
            <template v-slot:item.teacherIncharge1="{ item }">
              {{ item.teacherIncharge1 || '-' }}
            </template>
             <template v-slot:item.teacherIncharge1Mobile="{ item }">
              {{ item.teacherIncharge1Mobile || '-' }}
            </template>
             <template v-slot:item.teacherIncharge2="{ item }">
              {{ item.teacherIncharge2 || '-' }}
            </template>
             <template v-slot:item.teacherIncharge2Mobile="{ item }">
              {{ item.teacherIncharge2Mobile || '-' }}
            </template>
             <template v-slot:item.chiefMonitor="{ item }">
              {{ item.chiefMonitor || '-' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <div>
                <v-btn x-small class="px-2 ml-1 ma-1" color="red" outlined @click.prevent="viewStaff(item.driverID)">
                  View Driver Details
                </v-btn>
              </div>
                <div>
                    <router-link :to="{ name: 'viewVehicleBusRouteStop', params: { busRouteID: item.id } }">
                 <v-btn x-small class="px-2 ml-1 ma-1" color="blue" outlined >
                  Bus Stops
                </v-btn>
              </router-link>
                </div>
              <div>
                <router-link :to="{ name: 'editVehicleBusRoute', params: { busRouteID: item.id } }">
                <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                  <v-icon small> mdi-pencil</v-icon>
                </v-btn>
              </router-link>
              </div>

            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
    <div class="modal" :class="{ 'is-active': enableStaffModal }">
      <div class="modal-background"></div>

      <form class="modal-card" style="width: 1000px">
        <header class="modal-card-head">
          <p class="modal-card-title"><strong>View Driver Details</strong></p>
          <button class="delete" type="button" @click="this.toggleStaffModal"></button>
        </header>
        <v-data-table
            :footer-props="{
              'items-per-page-options': [5]
            }"
            :items-per-page="10"
            :headers="staffheaders"
            :items="vehicleDriverStaff"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              {{ item.name || '-' }}
            </template>
             <template v-slot:item.email="{ item }">
              {{ item.email || '-' }}
            </template>
             <template v-slot:item.mobileNumber="{ item }">
              {{ item.mobileNumber || '-' }}
            </template>
             <template v-slot:item.uniqueIdentificationNumber="{ item }">
              {{ item.uniqueIdentificationNumber || '-' }}
            </template>
             <template v-slot:item.licenseNumber="{ item }">
              {{ item.licenseNumber || '-' }}
            </template>
          </v-data-table>
      </form>
    </div>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'vehicleBusRoute',
  components: {
    MaterialCard,
    VCardComponent
  },
  data () {
    return {
      search: '',
      isLoading: false,
      loadingComponent: null,
      academicYears: [],
      academicYearID: '',
      stages: [],
      inProgress: false,
      franchiseeArr: [],
      franchiseeID: '',
      enableStaffModal: false,
      UserType: '',
      vehicleDriverStaff: [],
      status: '',
      vehicleBusRoute: [],
      total: '',
      headers: [
        { text: 'Vehicle Number', value: 'vehicleDetail', sortable: true },
        { text: 'Route Name', value: 'routeName', sortable: true },
        { text: 'Vehicle Route Type', value: 'isPickUp', sortable: true },
        { text: 'Teacher Incharge 1', value: 'teacherIncharge1', sortable: true },
        { text: 'Teacher Incharge 1 Mobile', value: 'teacherIncharge1Mobile', sortable: true },
        { text: 'Teacher Incharge 2', value: 'teacherIncharge2', sortable: true },
        { text: 'Teacher Incharge 2 Mobile', value: 'teacherIncharge2Mobile', sortable: true },
        { text: 'Chief Monitor', value: 'chiefMonitor', sortable: true },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ],
      staffheaders: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Mobile Number', value: 'mobileNumber', sortable: true },
        { text: 'Unique Identification Number', value: 'uniqueIdentificationNumber', sortable: true },
        { text: 'License Number', value: 'licenseNumber', sortable: true }
      ]
    }
  },
  async created () {
    await this.getYear()
    await this.getFranchiseeList()
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.Save()
        this.inProgress = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    viewStaff: async function (ID) {
      this.toggleStaffModal()
      this.loadingComponent = this.$buefy.loading.open()
      this.vehicleDriverStaff = []
      let response = await http.get(`${constants.API_URL}/api/transport/vehiclestaff/vehiclestaffdetails/${ID}`)
      this.vehicleDriverStaff = [response.data]
      this.loadingComponent.close()
    },
    toggleStaffModal: function () {
      this.enableStaffModal = !this.enableStaffModal
    },
    Save: async function () {
      this.vehicleBusRoute = []
      this.total = ''
      try {
        let getParam = {}
        if (this.franchiseeID.length === 0) {
          this.isLoading = false
          return this.$buefy.toast.open({
            message: 'Please select franchisee',
            type: 'is-danger',
            duration: 4000
          })
        } else {
          getParam.franchiseeID = this.franchiseeID
        }
        getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclebusroute`, {
          params: getParam
        })

        if (data.length === 0) {
          this.$buefy.dialog.alert({
            title: 'No Data',
            message: 'No Data Found',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          this.vehicleBusRoute = data
          this.vehicleBusRoute.forEach(element => {
            element.isPickUp = element.isPickUp === true ? 'Pick Up' : 'Drop'
          })
          this.total = this.vehicleBusRoute.length
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    }
  }
}
</script>
